import type { KeyboardEvent } from 'react';
import type { GetLabel } from '../types/feature';

type SearchProps = {
	searchValue: string;
	setSearchValue: (value: string) => void;
	getLabel: GetLabel;
};

export default function Search({ searchValue, setSearchValue, getLabel }: SearchProps) {
	const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
	};

	return (
		<div className="feature__controls--search">
			<div className="feature__controls--search-input">
				<form role="search" className="search-form" autoComplete="off">
					<input
						type="search"
						className="search-field"
						placeholder={getLabel('search_placeholder')}
						value={searchValue}
						name="s"
						onChange={(event) => setSearchValue(event.target.value)}
						onKeyDown={handleKeyDown}
					/>
					<div className={`search-form__clear ${searchValue ? 'show' : ''}`} onClick={() => setSearchValue('')}>
						<span></span>
						<span></span>
					</div>
				</form>
			</div>
		</div>
	);
}
